module.exports = __webpack_public_path__ + "img/app_header.9d689c27.png";